import { WebStorageStateStore } from "oidc-client-ts";
import type { AuthProviderProps } from "react-oidc-context";

const env = import.meta.env;

export const oidcConfig: AuthProviderProps = {
  authority: env.VITE_KEYCLOAK_ISSUER ?? "https://auth.khired.pk/realms/orixen",
  client_id: env.VITE_KEYCLOAK_CLIENT_ID ?? "orixen-fleet",
  redirect_uri: `${window.location.origin}/auth/callback`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  scope: "openid profile email",
  response_type: "code",
  loadUserInfo: false,
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // Strip the ?code=&state= from the URL after the auth code exchange so the
  // page is bookmarkable and doesn't re-trigger the exchange on refresh.
  onSigninCallback: () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};
